<template>
    <div class="preview-page">
        <PageBar>
            <div class="page-bar">
                <i class="el-icon-back" />
                <span class="colse" v-matomo="{ behaviorCategory: '华为Ads(批量搭建)', name: '生成预览(取消)' }" @click="handleCancel">取消</span>
                |
                <span class="add">批量创建</span>
                <el-button ><span class="prev" v-matomo="{ behaviorCategory: '华为Ads(批量搭建)', name: '生成预览(上一步)' }" @click="handleBack">上一步</span></el-button>
                <el-button type="primary" :loading="saveloading" @click="handleSave"
                    v-matomo="{ behaviorCategory: '华为Ads(批量搭建)', name: '提交创建' }"><span class="save">提交创建</span></el-button>
            </div>
        </PageBar>
        <div class="pt10 pb10 pl20 pr20 bg-color mt10 mb10">
            <p class="text-bold">目标账户与产品：</p>
            <p>
                <span class="text-bold"> 账户：</span>
                {{ account_info?.[0]?.account_name }}（ID：{{ account_info?.[0]?.account_id }}）；
                <span class="text-bold"> 产品：</span> {{app_info.map(item => item.app_name + '(' + item.app_id + ')').join('、')}}
            </p>
        </div>
        <div class="preview-content mt10 bg-color">
            <jt-table :data="tableData" style="width: 100%;margin-top: 10px;" stripe
                :header-cell-style="{ background: '#e8eaec', color: '#333' }" :row-class-name="tableRowClassName" size="mini"
                row-key="id" class="create_vivo_list" v-loading="loading"
                :affixConfig="{ offset: { top: 110, bottom: 0 } }" tooltip-effect="dark">
                <el-table-column label="序号" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">总计</span>
                        <span v-else>{{ ((currentPage - 1) * pageSize) + scope.$index }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="产品信息" min-width="200"  show-overflow-tooltip prop="apps">
                    <template slot-scope="{ row , $index}">
                        <span v-if="$index==0">-</span>
                        <template v-else>
                            <p >{{row.apps.product_name||'-'}}</p>
                            <p>ID: {{  row.apps.promotion_id }} </p>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="版位" min-width="200"  show-overflow-tooltip prop="creative_size_name">
                <template slot-scope="{ row , $index}">
                    <span v-if="$index==0">-</span>
                        <template v-else>
                            <p >{{row.creative_size_name||'-'}}</p>
                        </template>
                    </template>
                </el-table-column>

                <el-table-column label="计划信息" min-width="200">
                    <template slot-scope="{ row , $index}">
                        <span v-if="$index == 0">{{ row.plan_total }}</span>
                        <template v-else>
                            <p>计划状态：{{  row.campaign_info.plan_status_text}}</p>
                            <!-- <p>{{ row.campaign_info.store_name || '-' }}</p> -->
                            <p>计划ID: {{ row.campaign_info.campaign_id }} </p>
                            <p>计划名称: {{ row.campaign_info.campaign_name }} </p>
                            <p>推广产品: {{ row.campaign_info.product_type_text }} </p>
                            <p>当日预算: {{ row.campaign_info.daily_budget }} </p>
                            <p>计划类型: {{ row.campaign_info.campaign_type_text }} </p>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="任务信息"  min-width="300">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">{{ scope.row.adgroup_total }}</span>
                        <div v-else>
                            <p>任务状态：{{scope.row.adgroup_info.adgroup_status_text}}</p>
                            <p>任务名称：{{scope.row.adgroup_info.adgroup_name}}</p>
                            <p>任务ID：{{scope.row.adgroup_info.adgroup_id}}</p>
                            <p>智能分包渠道号：{{scope.row.adgroup_info.channel_pkg_number}}</p>
                            <el-tooltip class="item" effect="dark"  placement="top">
                                <div slot="content" style="max-height:500px; overflow:auto">
                                    <!-- <p>定向包ID：{{scope.row.adgroup_info.targeting_package_id}}</p> -->
                                    <p>定向包类型：{{scope.row.adgroup_info.targeting_package_scope_text}}</p>
                                    <p>投放开始日期：{{scope.row.adgroup_info.adgroup_begin_date}}</p>
                                    <p>投放结束日期：{{scope.row.adgroup_info.adgroup_end_date}}</p>
                                    <p>时间段类型 ：{{scope.row.adgroup_info.time_period_type_text}}</p>
                                    <p>时间段：{{scope.row.adgroup_info.time_period_text}}</p>
                                    <p>出价方式：{{scope.row.adgroup_info.price_type_text}}</p>
                                    <p>出价：{{scope.row.adgroup_info.price}}</p>
                                    <p>期望转化成本：{{scope.row.adgroup_info.conversion_cost}}</p>
                                    <p>ROI系数：{{scope.row.adgroup_info.roi_ratio}}</p>
                                    <p>版位ID：{{scope.row.creative_size_id}}</p>
                                    <p>版位：{{scope.row.creative_size_name}}</p>
                                    <p>智能提价标志：{{scope.row.adgroup_info.dyn_price_flag_text}}</p>
                                    <p>智能提价上限：{{scope.row.adgroup_info.dyn_price_upper_limit}}</p>
                                    <!-- <p>转化跟踪指标ID：{{scope.row.adgroup_info.tracking_id}}</p>
                                    <p>转化跟踪指标：{{scope.row.adgroup_info.tracking_id_text}}</p> -->
                                    <p>投放策略id：{{scope.row.adgroup_info.ocpc_strategy}}</p>
                                    <p>投放策略：{{scope.row.adgroup_info.ocpc_strategy_text}}</p>
                                    <p>深度优化类型：{{scope.row.adgroup_info.deep_optimize_type_text}}</p>
                                    <p>深度转化目标：{{scope.row.adgroup_info.deep_effect_target_text}}</p>
                                    <p>深度转化价格：{{scope.row.adgroup_info.deep_effect_price}}</p>
                                    <p>推广目的：{{scope.row.adgroup_info.objective_type_text}}</p>
                                    <p>多日频控N天M次中的N：{{scope.row.adgroup_info.fc_days}}</p>
                                    <p>多日频控N天M次中的M：{{scope.row.adgroup_info.fc_upper_times}}</p>
                                    <!-- <p>关键词：{{scope.row.adgroup_info.keywords}}</p> -->
                                </div>
                                <el-button type="text">更多</el-button>
                            </el-tooltip>
                            
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="创意名称" min-width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">-</span>
                        <span v-else>{{scope.row.creative_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="动态词包标识" min-width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">-</span>
                        <span v-else>{{scope.row.dyn_ad_text_flag}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创意模式" min-width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">-</span>
                        <span v-else>{{scope.row.creative_mode}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创意详情" min-width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">{{ scope.row.ad_total }}</span>
                        <div v-else>
                            <p>创意状态：{{scope.row.ad_status_text}}</p>
                            <p>文案：{{scope.row.title}}</p>
                            <p>描述：{{scope.row.description}}</p>
                            <p>品牌名称：{{scope.row.corporate}}</p>
                            <el-tooltip class="item" effect="dark"  placement="top">
                                <div slot="content" style="max-height:500px; overflow:auto">
                                    <p>落地页信息</p>
                                    <p>落地页类型：{{scope.row.landing_page_type_text}}</p>
                                    <p>落地页地址：{{scope.row.landing_page}}</p>
                                    <p>应用直达地址信息：{{scope.row.deeplink}}</p>
                                    <p>展示监控地址：{{scope.row.impression_monitor_url}}</p>
                                    <p>点击监控地址：{{scope.row.click_monitor_url}}</p>
                                    <p>按钮文案：{{scope.row.selected_text_id_text}}</p>
                                    <p>行业分类ID：{{scope.row.industry_id}}</p>
                                    <p>行业标签：{{scope.row.industry_labels}}</p>
                                    <p>创意模板ID：{{scope.row.template}}</p>
                                    <p>开屏提示文案</p>
                                    <p>摇一摇交互提示文案：{{scope.row.wave_txt}}</p>
                                    <p>滑动交互提示文案：{{scope.row.swipe_txt}}</p>
                                    <p>摇一摇加点击交互提示文案：{{scope.row.wave_clk_txt}}</p>
                                    <p>滑动加点击交互提示文案：{{scope.row.swipe_clk_txt}}</p>
                                    <p>开屏跳转提示文案：{{scope.row.redirect_txt}}</p>
                                    <p>服务卡片ID：{{scope.row.service_card_id}}</p>
                                    <p>优先跳转链接：{{scope.row.jump_priority}}</p>
                                </div>
                                <el-button type="text">更多</el-button>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="转化跟踪" min-width="200" show-overflow-tooltip prop="effect_tracking">
                    <template slot-scope="{ row , $index}">
                        <span v-if="$index == 0">-</span>
                        <template v-else>
                            <p>{{ row.effect_tracking.effect_name || '-' }}</p>
                            <p>ID: {{ row.effect_tracking.tracking_id }} </p>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="定向包" min-width="200"  show-overflow-tooltip prop="targeting_package">
                    <template slot-scope="{ row , $index}">
                        <span v-if="$index==0">-</span>
                        <template v-else>
                            <p >{{row.targeting_package.targeting_name||'-'}}</p>
                            <p>ID: {{  row.targeting_package.targeting_id }} </p>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="智能分包" min-width="200" show-overflow-tooltip prop="channel">
                    <template slot-scope="{ row , $index}">
                        <span v-if="$index == 0">-</span>
                        <template v-else>
                            <p>{{ row.channel.channel_pkg_name || '-' }}</p>
                            <p>渠道号: {{ row.channel.channel_pkg_number }} </p>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="创意" min-width="300" prop="material_list">
                    <template slot-scope="{ row , $index}">
                        <span v-if="$index == 0">-</span>
                        <template v-else>
                            <IdeaColumnTemp  :list="Array.from({ length: row.material_list.length> 3 ? 3 :row.material_list.length }).map((_,i)=>row.material_list[i])"/>
                                <el-button type="text"  v-if="row.material_list.length> 3" @click="openPreviewMaterialModal(row.material_list)">点击查看更多</el-button>
                        </template>
                    </template>
                </el-table-column>
            </jt-table>

            <div class="bg-color tar p20">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 30, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import PageBar from '@/components/PageBar/index.vue'
import { getBatchPreviewListApi, getBatchPreviewInfoApi, postBatchAdsSavaApi } from '@/api'
import IdeaColumnTemp from './components/ideaColumnTemp';
import { previewMaterialModal } from './modal/index'
export default {
    name: 'PreviewPage',
    components: {
        PageBar, IdeaColumnTemp
    },
    props: {
        pageParams: {
            type: Object,
            default: () => {
                return {};
            },
        },
        platId: {
            type: Number,
            default: 10
        }
    },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            total: 10,
            tableData: [],
            loading: false,
            saveloading: false,
            account_info: {},
            app_info: []
        }
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        openPreviewMaterialModal(list) {
            previewMaterialModal({ 
                props: { list },
             })
        },
        handleSizeChange(size) {
            this.pageSize = size;
            this.getTableData();
        },
        handleCurrentChange(page) {
            this.currentPage = page;
            this.getTableData();
        },
        async getTableData() {
            this.loading = true;
            try {
                const [listRes, infoRes] = await Promise.all([getBatchPreviewListApi({ plat_id: this.platId, task_id: this.pageParams.id, pn: this.currentPage, rn: this.pageSize }), getBatchPreviewInfoApi({ plat_id: this.platId, task_id: this.pageParams.id })])
                this.tableData = [...infoRes.data.total_info, ...listRes.data.list]
                this.total = listRes.data.totalCnt
                this.account_info = infoRes.data.account_info || {};
                this.app_info = infoRes.data.app_info || [];
            } catch (error) {
                this.$message.error(error.info);
            } finally {
                this.loading = false;
            }
        },
        handleSave() {
            this.saveloading = true;
            postBatchAdsSavaApi({
                task_id: this.pageParams.id,
                plat_id: this.platId
            }).then(res => {
                this.$message.success(res.info);
                window.localStorage.removeItem('huawei_ads_batch')
                this.$emit("to-page", "ListPage", true)
            }).catch(err => {
                this.$message.error(err.info);
            }).finally(() => {
                this.saveloading = false;
            })
        },
        handleBack() {
            this.$emit('to-page', 'ConfigPage')
        },
        handleCancel() {
            window.localStorage.removeItem('huawei_ads_batch')
            this.$emit('to-page', 'ListPage')
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex === 0) {
                return 'gray-row';
            }
            return '';
        },
    }
}   
</script>
<style lang="scss" scoped>
.preview-page {
    padding-top: 40px;

    // background-color: #fff;
    .bg-color {
        background-color: #fff;
    }

    .page-bar {
        background: #fff;
        height: 44px;
        border-radius: 6px;
        border-bottom: 1px solid #e2e2e2;
        line-height: 44px;
        font-size: 14px;

        .colse {
            margin-right: 6px;
            cursor: pointer;
        }

        .add {
            font-weight: bold;
            margin-left: 6px;
            margin-right: 30px;
        }
    }
}
</style>